export enum PaymentMethodsType {
    CREDITCARD = 'CreditCard',
    GIFTCARD = 'GiftCard',
    PAYPAL = 'PayPal',
    APPLEPAY = 'ApplePay',
    AFTERPAY = 'Afterpay',
}
